import  gql  from 'graphql-tag'

export const CREATE_AMOUNT_TERMS_WC = gql`mutation amountTermsWc($input: AmountTermsWCMutationInput!){
    amountTermsWc(input: $input){
        amountTermsWC{
            id
            data
        }
        errors{
            field
            messages
        }
    }
}`;